// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__peb2I","description":"MealItem_description__qiiMH","price":"MealItem_price__RnMQu"};